import axios from "axios";
import { getItem } from "../../features/authentication/utils/handleLocalStorage";
import { logoutUser } from "../../features/authentication/hooks/logoutUser";
const API_URL = import.meta.env.VITE_PROJECTS_API;

export const projectsApiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30 segundos
  headers: {
    "Content-Type": "application/json",
  }
});

projectsApiClient.interceptors.request.use(
  (config) => {
    let token = getItem("token");

    if (token) {
      // Eliminar comillas del token
      token = token.replace(/['"]+/g, '');
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

projectsApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, config } = error.response;
      if ((status === 401 || status === 403) && !config.url.includes("/logout")) {
        logoutUser();
      }
    }
    return Promise.reject(error);
  }
);
